// another helper file so you don't have to import
// through so many directories

import EvilTroop from "./EvilTroop";
import LilDemonTroop from "./LilDemonTroop";
import BattleOtterTroop from "./BattleOtterTroop";
import AlienTroop from "./AlienTroop";
import BabyCowTroop from "./BabyCowTroop";
import ChickphinTroop from "./ChickphinTroop";
import MagicPuppyTroop from "./MagicPuppyTroop";
import QuackerTroop from "./QuackerTroop";
import ZDogTroop from "./ZDogTroop";
import ClownGuyTroop from "./ClownGuyTroop";
import ClownLadyTroop from "./ClownLadyTroop";
import WitchTroop from "./WitchTroop";
import MamaCowTroop from "./MamaCowTroop";
import DinoTroop from "./DinoTroop";
import VolcanoTroop from "./VolcanoTroop";
import TankTroop from "./TankTroop";

export default {
  EvilTroop,
  LilDemonTroop,
  BattleOtterTroop,
  AlienTroop,
  BabyCowTroop,
  ChickphinTroop,
  MagicPuppyTroop,
  QuackerTroop,
  ZDogTroop,
  ClownGuyTroop,
  ClownLadyTroop,
  WitchTroop,
  MamaCowTroop,
  DinoTroop,
  VolcanoTroop,
  TankTroop
};
